import React, { FC } from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import CardMedia from '@mui/material/CardMedia'
import { SxProps } from '@mui/material'

import Button from './Button'
import SVGImage from './SVG'

import { themeApp } from '../themes'

interface ButtonHeader {
  title?: string
  href?: string
}

interface DefaultImage {
  height?: string
  width?: string
  text?: string
  sx?: SxProps
}

interface Header {
  title?: string
  imgSrc?: string
  text?: React.ReactNode | null
  defaultImage?: DefaultImage
  button?: ButtonHeader
  imageStyle?: SxProps
  imgFit?: string
  sectionLeftStyle?: SxProps
}

interface GridHeaderProps {
  header?: Header
  section?: React.ReactNode
  bgColor?: string
  color?: string
}

const defaultProps: GridHeaderProps = {
  header: {
    title: '',
    imgSrc: '',
    imgFit: 'cover',
    text: null,
    defaultImage: {
      height: '100%',
      width: '100%',
      text: '',
    },
    button: {
      title: '',
      href: '',
    },
  },
  section: null,
  bgColor: '#e0efea',
  color: 'secondary.dark',
}

const GridHeader: FC<GridHeaderProps> = ({ header, section, bgColor, color }) => {
  console.log(header)

  return (
    <>
      {/* Section 1 */}
      <Box
        display='flex'
        justifyContent='center'
        sx={{
          backgroundColor: `${bgColor}`,
        }}
      >
        <Grid
          container
          sx={{
            py: {
              xs: '10px',
              md: '40px',
              lg: '40px',
            },
            pb: {
              md: '0px !important',
            },
            maxWidth: themeApp.maxWidth,
          }}
        >
          <Grid
            item
            xs={12}
            md={3}
            lg={4}
            sx={{
              px: {
                xs: 1,
                md: '10px',
              },
              pb: {
                xs: '25px',
                md: '15px',
                lg: 0,
              },
            }}
          >
            <Typography
              variant='h1'
              color='secondary.dark'
              textTransform='uppercase'
              fontStyle='italic'
              fontWeight='400'
              sx={{
                mb: {
                  xs: 2,
                  md: 3,
                  lg: 5,
                },
                textAlign: {
                  xs: 'center',
                  lg: 'left',
                },
                fontSize: {
                  xs: '16px',
                  md: '20px',
                  lg: '42px',
                },
              }}
            >
              {header?.title}
            </Typography>
            <Box
              sx={{
                height: '240px',
                width: {
                  xs: '100%',
                  md: '350px',
                  lg: '400px',
                },
                ml: {
                  xs: 0,
                  lg: '10vw',
                },
                position: 'relative',
                mb: {
                  lg: '50px',
                },
                ...header?.imageStyle,
              }}
            >
              {header && header?.imgSrc ? (
                <CardMedia
                  image={header?.imgSrc}
                  component='img'
                  sx={{
                    width: '100%',
                    height: '100%',
                    userSelect: 'none',
                    objectFit: header?.imgFit ?? 'cover',
                    objectPosition: 'center',
                    position: 'absolute',
                  }}
                />
              ) : null}

              {header && header?.defaultImage && header?.imgSrc === undefined ? (
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                  }}
                >
                  <SVGImage
                    width={header?.defaultImage?.width}
                    height={header?.defaultImage?.height}
                    text={header?.defaultImage?.text}
                  />
                </div>
              ) : null}
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={9}
            lg={8}
            display='flex'
            justifyContent='end'
            sx={{
              pl: {
                xs: 2,
                md: 25,
                lg: 30,
              },
              pr: {
                xs: 2,
                md: 5,
                lg: 10,
              },
              pt: {
                xs: 2,
                md: 5,
                lg: '3.125rem',
              },
              pb: {
                xs: 2,
                md: 0,
                lg: 0,
              },
              color,
              backgroundColor: '#FFFFFF',
              ...header?.sectionLeftStyle,
            }}
          >
            <Box display='flex' flexDirection='column' flex={1}>
              {header?.text}
              <div style={{ width: '100%' }}>
                {header && header.button ? (
                  <Button
                    variant='contained'
                    href={header?.button?.href}
                    sx={{
                      color: 'secondary.dark',
                      px: '50px',
                      borderRadius: '50px',
                      fontSize: {
                        xs: '14px',
                        lg: '18px',
                      },
                      fontWeight: 'bold',
                      alignSelf: 'start',
                      mx: 'auto',
                      mt: {
                        xs: 1,
                        md: 6,
                        lg: '30px',
                      },
                      mb: {
                        xs: 3,
                        md: -6,
                        lg: '-100px',
                      },
                      float: 'left',
                    }}
                  >
                    {header?.button?.title}
                  </Button>
                ) : null}
              </div>
            </Box>
          </Grid>
        </Grid>
      </Box>
      {/* Section 2 */}
      <Box
        maxWidth='lg'
        display='flex'
        flexDirection='column'
        alignItems='center'
        sx={{
          pt: {
            xs: 5,
            md: 15,
            lg: 20,
          },
          pb: {
            xs: 5,
            md: 5,
            lg: 10,
          },
          mx: 'auto',
          backgroundColor: '#FFFFFF',
        }}
      >
        {section}
      </Box>
    </>
  )
}

GridHeader.defaultProps = defaultProps

export default GridHeader
